import { render, staticRenderFns } from "./ProductRules.vue?vue&type=template&id=152b1a9e"
import script from "./ProductRules.vue?vue&type=script&lang=js"
export * from "./ProductRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152b1a9e')) {
      api.createRecord('152b1a9e', component.options)
    } else {
      api.reload('152b1a9e', component.options)
    }
    module.hot.accept("./ProductRules.vue?vue&type=template&id=152b1a9e", function () {
      api.rerender('152b1a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/ProductRules.vue"
export default component.exports